import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/home/HeroSection';
import { OpportunityCategories } from '@/components/home/OpportunityCategories';
import { FeaturedOpportunities } from '@/components/home/FeaturedOpportunities';
import { BlogSection } from '@/components/home/BlogSection';
import { CTASection } from '@/components/home/CTASection';
import { AdDisplay } from '@/components/ads/AdDisplay';
import { OnboardingTour } from '@/components/OnboardingTour';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <OpportunityCategories />
        <FeaturedOpportunities />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
      <AdDisplay />
      <OnboardingTour />
    </div>
  );
};

export default Index;
